import { Injectable } from '@angular/core';
import { IdleDeadline } from 'requestidlecallback';

@Injectable()
export abstract class IdleCallbackService<T = any> {
    public abstract runWhenIdle(callback: (deadline?: IdleDeadline) => void): T;
    public abstract cancelIdleCallback(handle: T): void;
}
